<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pSryPv/tc-custom/9781681882147.jpg?1728851631859" alt="This image is the cover for the book Grill School, Williams-Sonoma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grill School, Williams-Sonoma
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>New York Times</i>-bestselling authors, a guide to grilling with failproof techniques and over sixty-five mouthwatering recipes.</b><br/><br/> In this guide and cookbook, two grill experts break down the essential information you need to graduate grill school. Learn about different types of grills and equipment and master the eight fundamental grilling techniques, including direct and indirect grilling, smoking, and la plancha. Organized by main ingredient and type of dish, each chapter features fresh recipes with flavor profiles inspired from around the globe. You’ll find engaging lessons that break down the techniques for getting the best results with burgers, steak, salmon, vegetables, and more. This enticing collection includes over sixty-five recipes for burgers, beef, pork, poultry, fish &amp; shellfish, vegetables, pizzas, and desserts—plus an entire chapter on brines, rubs, and sauces.<br/><br/><b>Recipes include:</b> Tunisian Turkey Burgers with Harissa Ketchup; BBQ Brisket with Ancho Chocolate BBQ Sauce; 3-Pepper Spareribs with Peach Bourbon Barbecue Sauce; Grilled Chicken Tikka Masala; Planked Salmon Fillet with Citrus Rub and Artichoke Relish; Grilled Squid with Chorizo and Romesco; Grill Woked Broccoli and Cauliflower Florets with Tom Kha Ga Glaze; Grilled Fennel Basted with Rosemary Absinthe; Grilled Pizza with Black Garlic, Arugula &amp; Soppressata; Barely Burnt Honey Glazed Pears with Orange and Rosemary; and more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Schloss, David Joachim
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aaab0cbc